import { render, staticRenderFns } from "./VideoAd.vue?vue&type=template&id=88e4702e"
import script from "./VideoAd.vue?vue&type=script&lang=js"
export * from "./VideoAd.vue?vue&type=script&lang=js"
import style0 from "./VideoAd.vue?vue&type=style&index=0&id=88e4702e&prod&lang=scss"
import style1 from "./VideoAd.vue?vue&type=style&index=1&id=88e4702e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports